export const RemoveWatermarkModal: string = 'RemoveWatermarkModal';
